// extracted by mini-css-extract-plugin
export var deleteIcon = "_ui-5";
export var deleteOption = "_ui-3";
export var divider = "_ui-2";
export var downloadIcon = "_ui-4";
export var drawer = "_ui-0";
export var drawerFooter = "_ui-6";
export var drawerOpen = "_ui-1";
export var highlighted = "_ui-7";
export var lighterHighlight = "_ui-8";